import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip, DatePicker } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { connect } from 'react-redux';
import { EditIcon, AlertIcon, Menu as MenuIcons, AlertCircleIcon, CloseIcon, FormIcon, ExcelIcon, PDFIcon, CSVIcon, TXTIcon } from 'assets/icons';
import moment from 'moment';
import { CompanyService, ReportService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const FORMATS = {
	EXCEL: 1,
	PDF: 2,
	CSV: 3,
	TXT: 4
}

class ExportBills extends React.Component<Props> {

	state = {
		form: {
			company_id: -1,
			since: '',
			until: '',
			format: FORMATS.EXCEL
		},
		companies: [],
		default_company: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Exportar datos',
				onBack: null,
				subtitle: 'Selecciona los filtros y el formato para exportar la información registrada.',
				color: '#edf0fe',
				icon: MenuIcons.Menu6
			}
		});

		this.loadCompanies();
	}

	loadCompanies = async () => {
		const res: any = await CompanyService.admin.get({
			withoutLoading: true
		});
		this.setState({
			companies: res.companies || [],
			default_company: res.default_company
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async () => {
		const res: any = await ReportService.admin.bills.export({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		if (res.url) {
			Print(Globals.generateS3(res.url,true,res.provider));
		}
	}

	render() {
		return (
			<div id="export-bills">
				<div className="white-container">
					<div className="blue-container">
						<img src={ AlertCircleIcon } />
						<div>
							<p className="bold">Información</p>
							<p>Los datos exportados incluirán todos los registros que coincidan con los filtros seleccionados.</p>
						</div>
					</div>
					<div className="container-border">
						<div className="row">
							{
								this.state.companies?.length > 0 && (
									<div className="col-md-3">
										<Select
											color="white"
											placeholder="Seleccionar"
											label="Empresa"
											name="company_id"
											onChange={ (e: any) => this.change(e) }
											value={ this.state.form.company_id }
											options={ [
												// @ts-ignore
												{ value: -1, label: (this.state.default_company?.name || '') + ' ' + (this.state.default_company?.lastname || '') },
												...this.state.companies.map((item: any) => {
													return {
														value: item.id,
														label: item?.name
													}
												})
										] } />
									</div>
								)
							}
							<div className="col-md-3">
								<DatePicker
									label="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										});
									} }
									maxDate={ moment().toDate() }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md-3">
								<DatePicker
									label="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										});
									} }
									maxDate={ moment().toDate() }
									value={ this.state.form.until }
								/>
							</div>
							<div className="col-md-3">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Formato"
									name="format"
									onChange={ (e: any) => this.change(e) }
									value={ this.state.form.format }
									options={ [
										{ value: FORMATS.EXCEL.toString(), label: 'Excel' },
										// { value: FORMATS.PDF.toString(), label: 'PDF' },
										{ value: FORMATS.CSV.toString(), label: 'CSV' },
										{ value: FORMATS.TXT.toString(), label: 'TXT' },
									] } />
							</div>
						</div>

						<div className="blue-container">
							<img src={ FormIcon } />
							<div>
								<div className="row">
									<div className="col-md-6 justify-content-center" style={{ display: 'flex', flexDirection: 'column' }}>
										<p className="bold">Formatos disponibles</p>
										<p>Puedes exportar la información en los siguientes formatos:</p>
									</div>
									<div className="col-md-6">
										<div className="row">
											<div className="col-md-4">
												<div className="format">
													<img src={ ExcelIcon } />
													<p>Excel (.xlsx)</p>
												</div>
											</div>
											<div className="col-md-4">
												<div className="format">
													<img src={ CSVIcon } />
													<p>CSV (.csv)</p>
												</div>
											</div>
											<div className="col-md-4">
												<div className="format">
													<img src={ TXTIcon } />
													<p>TXT (.txt)</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<hr />
					<div className="text-right">
						<div className="row row-buttons">
							<div className="col-md-12">
								<button className="btn btn-submit" onClick={ this.submit }>
									<img src={ MenuIcons.Menu14 } />
									Exportar datos
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ExportBills);